export default __webpack_public_path__ + "static/media/logo_origon.9fc4a844.svg";